export default function getSitesWithoutPaginationReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SITES_WITHOUT_PAGINATION_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SITES_WITHOUT_PAGINATION_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SITES_WITHOUT_PAGINATION_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}